import { Typography } from "@mui/material";
import AppButton from "component/button/AppButton";
import FailIcon from "component/failIcon/FaiIcon";
import InfoIcon from "component/infoIcon/InfoIcon";
import SuccessIcon from "component/successIcon/SuccessIcon";
import React from "react";
import styles from "./AuthModalLayout.module.css";

function AuthModalLayout({
  loading,
  icon,
  primaryText,
  secondaryText,
  handleClose,
  btnText,
  handleClickSecondaryBtn,
  secondaryBtn,
}) {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
      className={styles.auth_modal_layout}
    >
  {icon === "success" &&  <SuccessIcon/>}
        {icon === "error" &&     <FailIcon/>}
        {icon === "info" &&   <InfoIcon/>}
      <Typography variant="h6">{primaryText}</Typography>
      <Typography>{secondaryText}</Typography>
      <div className={styles.btn}>
        <AppButton
          loading={loading}
          handleAction={() => {
            handleClose();
          }}
          fullwidth
          textColor="#FFFFFF"
          btnBg="#0072CE"
          btnText={btnText || "Close"}
        />
      </div>
      {secondaryBtn && (
        <div className={styles.btn}>
          <AppButton
            handleAction={() => {
              handleClickSecondaryBtn();
            }}
            fullwidth
            textColor="black"
            btnBg="white"
            btnText={"Close"}
          />
        </div>
      )}
    </div>
  );
}

export default AuthModalLayout;
